import { BusinessPaymentsSuccess } from '../../../../components/service/business/BusinessPaymentsSuccess';
export const BusinessPaymentsSuccessPageView = () => {
  return <BusinessPaymentsSuccess data-sentry-element="BusinessPaymentsSuccess" data-sentry-component="BusinessPaymentsSuccessPageView" data-sentry-source-file="success.tsx" />;
};